import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes, authGard, clearStores } from './routes';

Vue.use(VueRouter);

// routingを設定
const router = new VueRouter(routes);
router.beforeEach(authGard);
router.afterEach(clearStores);

export default router;
